import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { actions } from '../../../modules/product/redux/productActions';
import { useCallRecording } from './useCallRecording';
import './PaymentIFrame.scss';

const PaymentIFrame = ({
  onSuccess,
  onFail,
  showPaymentIframe,
  onMuteCall,
  onResumeCall,
}) => {
  const { show, transactionId } = useSelector((state) => state.product?.paymentIframe);
  const [showButton, setShowButton] = useState(false);

  useCallRecording(show, onMuteCall, onResumeCall);

  useEffect(
    () => {
      const timer = setTimeout(() => {
        setShowButton(true);
      }, 120000);
      return () => clearTimeout(timer);
    },
    [show],
  );

  const handleTransaction = (event) => {
    const { status, policy, message } = event.data;
    if (status === 'complete') {
      showPaymentIframe(false, '');
      onSuccess(policy?.policy_id);
    }

    if (status === 'failed') {
      showPaymentIframe(false, '');
      onFail(message);
    }
  };

  const onCancel = () => {
    showPaymentIframe(false, '');
    setShowButton(false);
  };
  useEffect(
    () => {
      window.addEventListener('message', handleTransaction);
      return () => {
        window.removeEventListener('message', handleTransaction);
      };
    },
    [show],
  );

  if (!show) {
    return null;
  }

  const url = axios.defaults.baseURL + `/public/transactions/${transactionId}:pay`;

  return (
    <Modal show={show} dialogClassName="payment-iframe-modal" onHide={onCancel}>
      {showButton && <Modal.Header bsClass={'payment-modal-header'} closeButton />}
      <iframe src={url} className="payment-iframe-modal--iframe" />
    </Modal>
  );
};

export default connect(
  null,
  {
    showPaymentIframe: actions.showPaymentIframe,
    onMuteCall: actions.muteCall,
    onResumeCall: actions.resumeCall,
  },
)(PaymentIFrame);
